import { FeeProcedure, FeeScheduleGroupKey } from '@bariendo/lib/receivables';
import { BILL_TO_LABEL } from './receivableRows';

/** The fee schedule's procedures, in the prototype's order (BAR-3039). */
export const FEE_PROCEDURES: { value: FeeProcedure; label: string }[] = [
  { value: 'ESG', label: 'ESG' },
  { value: 'ESG_MAX', label: 'ESG Max' },
  { value: 'IGB', label: 'IGB' },
  { value: 'SIS', label: 'SIS' },
  { value: 'TORE', label: 'TORe' },
  { value: 'CONSULTATION_FEE', label: 'Consultation fee' },
];

export const feeGroupKey = (group: FeeScheduleGroupKey): string => `${group.billTo}|${group.location}`;

/** `Carrum`, or `MUSC Health · Greater Charleston`. */
export function feeGroupName(group: FeeScheduleGroupKey): string {
  const payor = BILL_TO_LABEL[group.billTo];
  return group.location === 'All' ? payor : `${payor} · Greater ${group.location}`;
}
